module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "element element-non-bodymatter element-container-single element-type-none element-with-heading full-character-formatting",
    attrs: {
      "id": "uncategorized"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title case-upper"
  }, [_vm._v("Book Description")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "uncategorized-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_vm._v("For Jon and Marianna Knox, the birth of their daughter Persephone marks the happiest day of their lives. Until they learn that Persey is suffering from a rare but fatal condition called “triploidy.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Her doctors are baffled. And with good reason, because the source of the little girl’s genetic malfunction is not of this Earth. It lies out beyond the orbit of Saturn.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("And it’s coming for all of us.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0feff2f1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bookdescription.vue
// module id = 60
// module chunks = 0